import React from 'react';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import { red, yellow, orange } from '@mui/material/colors';

const Theme = ({ children }) => {
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: red[700],
      },
      warning: {
        main: orange[700],
      },
    },
    typography: {
      subtitle1: {
        fontWeight: 'bold',
      },
      subtitle2: {
        fontWeight: 'bold',
      },
    },
  });

  const theme = createTheme(darkTheme, {
    palette: {
      danger: darkTheme.palette.augmentColor({
        color: {
          main: yellow[600],
        },
        name: 'danger',
      }),
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
